import axios from "axios";
var CryptoJS = require("crypto-js");
const newBaseUrl = "https://asia-south1-psychic-torus-241914.cloudfunctions.net/qatar_tourism_cloud_functions-test/";
 //const newBaseUrl = "https://asia-south1-psychic-torus-241914.cloudfunctions.net/qatar_tourism_cloud_functions-test/";
// const newBaseUrl = "https://me-central1-qta-dev-spoke-service.cloudfunctions.net/qatar_tourism_cloud_functions-test/";
// const newBaseUrl = "https://me-central1-qc-gcp-dev-media-library.cloudfunctions.net/qatar_tourism_cloud_functions-test/"
//const newBaseUrl = "https://qt-medialibrary-be-484629544897.me-central1.run.app/"

export async function apiCalling(url, postData) {
    let baseUrl = newBaseUrl + url
    const data = await axios.post(baseUrl, postData);
    const res = data;
    return res;
}

export async function apiCallingPost(url, postData) {
    let baseUrl = newBaseUrl + url;
    const ENC_KEY = process.env.REACT_APP_ENCRYPTION_KEY; // 32 DIGITS

    try {
        const response = await axios.post(baseUrl, postData);
        // console.log("...response...",response);
        
        const bytes = CryptoJS.AES.decrypt(response.data.token, ENC_KEY);
        let decryptedData = bytes.toString(CryptoJS.enc.Utf8);
        decryptedData = JSON.parse(decryptedData);
        // console.log("...decryptedData...",decryptedData);

        return {
            data: decryptedData,
        };
    } catch (error) {
        console.error("Error in API call:", error);
        throw error; // Re-throw or handle the error appropriately
    }
}
export async function apiCallingGetDecrypted(url) {
    const baseUrl = newBaseUrl + url;
    return {
        responseData: baseUrl
    };
}